/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unlimitedplaces1Inputs */

const en_unlimitedplaces1 = /** @type {(inputs: Unlimitedplaces1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited places`)
};

const de_unlimitedplaces1 = /** @type {(inputs: Unlimitedplaces1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbegrenzte Orte`)
};

/**
* | output |
* | --- |
* | "Unlimited places" |
*
* @param {Unlimitedplaces1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const unlimitedplaces1 = /** @type {((inputs?: Unlimitedplaces1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unlimitedplaces1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_unlimitedplaces1(inputs)
	return de_unlimitedplaces1(inputs)
});
export { unlimitedplaces1 as "unlimitedPlaces" }